export enum CuttingPaySystemType {
  Invoice,
  Psb,
  PayPal,
  Wooppay,
}

export class CuttingPaySystemInfo {
  systemType: CuttingPaySystemType;
  commissionPercentage: number;

  constructor(payInfo?: CuttingPaySystemInfo | any) {
    payInfo = payInfo || {};
    this.systemType = payInfo.systemType || CuttingPaySystemType.Invoice;
    this.commissionPercentage = payInfo.commissionPercentage || 0;
  }
}
